import { Component, OnInit, Input} from '@angular/core';
import {FireService} from '../fire.service'

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  @Input() email: string = ""
  @Input() message: string = ""

  constructor(
    public fireService: FireService
  ) { }

  ngOnInit(): void {
  }

  saveData(): void {
    const reachOut = {
      email: this.email,
      message: this.message
    }
    this.fireService.putData(reachOut)
  }

}
